import * as React from 'react';

const SendIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={22} viewBox="0 0 22 22" width={22} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.2936 2.79835C17.2971 0.648252 2.27911 5.91527 2.29151 7.83825C2.30557 10.0189 8.15642 10.6897 9.7781 11.1448C10.7533 11.4183 11.0145 11.6988 11.2394 12.7214C12.2578 17.3528 12.7691 19.6564 13.9345 19.7078C15.792 19.7899 21.242 4.89667 19.2936 2.79835Z"
            stroke="white"
            strokeWidth={2}
        />
        <path
            d="M10.542 11.4583L13.7503 8.25"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
        />
    </svg>
);
export default SendIcon;
